(ns rlws.iot-cloud.frontend.components
  (:require [clojure.string :as str]
            [fork.re-frame :as fork]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [rlws.iot-cloud.frontend.config :as config]
            [rlws.iot-cloud.frontend.events :as events]
            [rlws.iot-cloud.frontend.forms :as forms]
            [rlws.iot-cloud.frontend.navigation :as nav]
            [rlws.iot-cloud.frontend.routes :as routes]
            [rlws.iot-cloud.frontend.subscriptions :as sub]
            [rlws.iot-cloud.validation :as validation]
            [rlws.iot-cloud.frontend.site :as site]
            [vlad.core :as vlad]
            [cljs.pprint :as pprint]))

(defn pprint-str
  [x]
  (with-out-str (pprint/pprint x)))

(defn pprint-code
  "If the app is running in dev environment, renders a pretty printed
  representation of the given object"
  [x]
  (when @(rf/subscribe [:debug?])
    [:code
     {:style {:text-align "left"}}
     [:pre (pprint-str x)]]))

(defn loader
  []
  [:div.spinner.spinner-dark])

(defn page-loader
  []
  [:div.center
   [:h3.margin-bottom-lg "Loading..."]
   [loader]])

(defn modal-container
  [{:keys [child title state]}]
  [:div.modal-wrapper
   [:div.modal-backdrop
    {:on-click (fn [event]
                 (rf/dispatch [:modal {:show? false
                                       :child nil}])
                 (.preventDefault event)
                 (.stopPropagation event))}]
   [:div.modal-child
    [:div.modal__box-header
     {:class (case state
               :red "modal__box-header--error"
               "")}
     [:h4.modal__box-header-title title]
     [:i.modal__box-header-icon.fas.fa-times
      {:on-click (fn [event]
                   (rf/dispatch [:modal {:show? false
                                         :child nil}])
                   (.preventDefault event)
                   (.stopPropagation event))}]]
    [:div.modal__box-body
     (if (fn? child)
       [child]
       child)]
    [:div.modal__box-footer]]])

(defn modal
  []
  (let [modal (rf/subscribe [:modal])]
    (fn []
      (when (:show? @modal)
        [modal-container @modal]))))

(defn breadcrumb
  "data is a vector of maps i.e. {:label 'bar' :href 'foo'}"
  [data]
  [:div.breadcrumb
   (for [{:keys [label href]} (drop-last data)]
     ^{:key label}
     [:<>
      [:a.breadcrumb__link
       {:href href}
       label]
      [:span.breadcrumb__divider " / "]])
   [:a.breadcrumb__link.breadcrumb--active
    {:href (:href (last data))}
    (:label (last data))]])

(defn logo
  [sidebar?]
  (let [brand-logo @(rf/subscribe [::sub/brand-logo])]
    (if sidebar?
      [:div.logo
       [:img.logo-img
        {:src (or brand-logo "/img/virtulink-full-inv.svg")}]]
      [:img.logo-img--mobile
       {:src (or brand-logo "/img/virtulink-inv.svg")}])))

(defn header
  [current-page]
  (let [{:keys [path-params]} @(rf/subscribe [::sub/current-route])
        page @(rf/subscribe [::sub/page])
        page-title @(rf/subscribe [::sub/page-title])
        asset @(rf/subscribe [::sub/current-asset])
        customer @(rf/subscribe [::sub/data :customer])
        show-menu? @(rf/subscribe [:show-menu?])
        {:keys [primary-color]} @(rf/subscribe [::sub/customizations])]
    [:div.header 
     {:class (when show-menu? "nav-open")
      :style (if primary-color
               {:background-color primary-color}
               {})}
     [:div.header__container
      [:a.header--desktop
       [:i.fas.fa-bars
        {:on-click #(rf/dispatch [:menu-toggle])}]]
      [:a.mobile-logo
       {:on-click #(rf/dispatch [:menu-toggle])}
       [logo false]]
      (when (= page :customers)
        [:span {:style {:font-size "20px"
                        :font-style "normal"
                        :font-weight "700"
                        :line-height "32px"}} page-title])
      (when (= page :asset)
        [:div.header__user
         [:div.user__icon
          [:img {:src "/img/Customer_W.svg"}]]
         [:div.user__name
          (get-in asset [:customer :name])]])
      (when (= page :iqube-detail)
        [:div.header__user
         [:div.user__icon
          [:img {:src "/img/Customer_W.svg"}]]
         [:div.user__name
          (get-in asset [:customer :name])]])
      (when (or (= page :customer) (= page :site))
        (if (or (= (site/to-plain-id customer) (:customer path-params)) (= page :site))
          [:span {:style {:font-size "20px"
                          :font-style "normal"
                          :font-weight "700"
                          :line-height "32px"}} (:name customer)]
          [:span {:style {:font-size "20px"
                          :font-style "normal"
                          :font-weight "700"
                          :line-height "32px"}} "Customers"]))
      [:div.header__icons 
       [:a.header--mobile
        [:i.fas.fa-bars
         {:on-click #(rf/dispatch [:menu-toggle])}]]]]
     #_[:div.header__page-title
        [:h1 page-title]]]))

(defn subheader
  [{:keys [fixed? box-shadow?]} & children]
  (let [show-menu? @(rf/subscribe [:show-menu?])]
    (into [:div.subheader
           {:class [(when fixed? "fixed")
                    (when show-menu? "nav-open")]}]
          children)))

(defn fixed-container
  [{:keys [class]} & children]
  (let [show-menu? @(rf/subscribe [:show-menu?])]
    (into [:div
           {:class (concat ["fixed-container"
                            (when show-menu? "nav-open")]
                           (if (coll? class) class [class]))}]
          children)))

(defn navigation
  [current-page]
  (let [show-menu? @(rf/subscribe [:show-menu?])
        current-user @(rf/subscribe [::sub/current-user])]
    [:div.nav
     {:class (when show-menu? "open")}
     [logo true]
     [:div.menu
      [:ul
       (for [{:keys [name link-text disabled? icon active-pages permission-required]}
             (filter :icon routes/pages)
             :when (contains? (set (:permissions current-user)) permission-required)]
         ^{:key link-text}
         [:li
          {:class (when (or (= current-page name)
                            (and active-pages
                                 (active-pages current-page))) "active")}
          [:a {:href (when name (nav/route->url name))}
           [:span.menu__icon
            {:class icon}]
           [:span.text link-text]]])]]
     [:div.settings__mobile
      [:div.menu
       [:ul
        [:li [:a {:href (nav/route->url :account-settings)}
              [:i.menu__icon.fas.fa-fw.fa-cog]
              [:span.text "Account Settings"]]]
        [:li [:a {:href (nav/route->url :notification-settings)}
              [:i.menu__icon.fas.fa-fw.fa-bell]
              [:span.text "Notification Settings"]]]
        [:li [:a {:href "/docs/EULA.pdf"}
              [:i.menu__icon.fas.fa-fw.fa-file]
              [:span.text "EULA"]]]
        [:li [:a
              (if (contains? (set (:roles current-user)) "customer-user")
                {:href "https://virtulink.ricelake.com/cmr/index.htm"
               :target "_blank"}
                {:href "https://virtulink.ricelake.com/dlr/index.htm"
                 :target "_blank"})
              [:i.menu__icon.fas.fa-fw.fa-question-circle]
              [:span.text "Help"]]]
        [:li [:a
              {:on-click #(rf/dispatch [:logout])}
              [:i.menu__icon.fas.fa-fw.fa-sign-out-alt]
              [:span.text "Logout"]]]]]]
     [:div.settings__desktop
      {:on-click #(rf/dispatch [:toggle-settings])}
      [:div.menu__settings
       [:i.menu__icon.fas.fa-fw.fa-cog]]]
     [:div.branding-logo.bg-black
      [:img {:src "/img/VirtuLink_VirtuLink Powered Rev.svg"}]]
     [:div.close-nav
      [:i.fa.fa-times {:on-click #(rf/dispatch [:menu-toggle])}]]]))

(defn page-title
  ([props]
   (page-title props nil))
  ([{:keys [title]} action]
   [:div
    [:div.page__title-container
     [:h1.page__title title]
     (when action action)]
    [:hr.page__title-hr]]))

(defn page-subtitle
  ([props]
   (page-subtitle props nil))
  ([{:keys [subtitle description]} action]
   [:div.page__subtitle-container
    [:div
     [:h2.page__subtitle subtitle]
     (when description
       [:div.page__subtitle-description description])]
    (when action action)]))

(defn page-menu-item
  [{:keys [path link-text nav-icon]} li-props]
  [:a {:href path}
   [:div.sidenav__item
    [:img {:src (str "/img/" nav-icon)}]
    [:li li-props link-text]]])

(defn sidenav-wrapper
  [content]
  (let [user @(rf/subscribe [::sub/user])
        admin? (= :admin (:role user))
        page-title @(rf/subscribe [::sub/page-title])]
    [:<>
     [:div.sidenav__header
      [:div.sidenav__logo "RLWS"]
      [:div.sidenav__user (some-> user
                                  :email
                                  str/capitalize)]]
     [:div.sidenav
      [:div.sidenav__divider]
      [:ul.menu-items
       [:<>
        (for [{:keys [path link-text] :as item}
              (filter :nav-icon routes/pages)]
          ^{:key path}
          [page-menu-item
           item
           {:class ["menu-item"
                    (when (= page-title link-text)
                      "menu-item--active")]}])
        [:a
         {:on-click #(rf/dispatch [:logout])}
         [:div.sidenav__item
          [:i.fa.fa-sign-out
           {:style {:color     "#8B9AA6"
                    :font-size "1.5em"}}]
          [:li {:class "menu-item"}
           "Logout"]]]]]]
     [:div.main
      content]]))

(defn info-group-component
  [id data]
  [:div.summary-details
   (for [{:keys [label value icon]} data]
     ^{:key (str id label value)}
     [:div.summary-details__group
      [:div.summary-details__icon
       [:i {:class icon}]]
      [:div
       [:div.summary-details__label (str label)]
       [:div.summary-details__value (str value)]]])])

(defn image-gallery
  [images]
  (let [visited (r/atom (:url (first images)))]
    (fn [images]
      (let [visited-deref @visited]
        [:div
         [:img.gallery-image
          {:src visited-deref}]
         [:div.gallery-thumbnails
          (for [{:keys [url]} images]
            ^{:key url}
            [:img.gallery-thumbnails__thumbnail.thumbnail--disabled
             {:class    (when (= visited-deref url) "thumbnail--active")
              :src      url
              :on-click #(reset! visited url)}])]]))))

(defn image-upload
  [{:keys [state style] :as props}]
  [:div
   (when @state
     [:div (merge {:style {:max-width  "200px"
                           :max-height "250px"}} props)
      [:img {:src @state :alt "Uploaded Image"}]])
   [:div
    [:input
     {:type      "file"
      :on-change (fn [event]
                   (let [file (first (.. event -target -files))]
                     (let [file-reader (js/FileReader.)]
                       (. file-reader readAsDataURL file)
                       (set!
                        (. file-reader -onload)
                        (fn [event]
                          (reset! state (.. event -target -result)))))))}]]])

;; -----------------------------------------------------------------------------
;; FORMS

(defn auth-error
  [error]
  (when error
    [:div.error error]))

(defn auth-wrap
  [component]
  [:<>
   [:div.auth-form-wrap
    [:img.auth-form-wrap__logo.m-auto
     {:style {:max-width "320px"
              :padding   "2em"
              :height    "140px"}
      :src   "/img/virtulink-full.svg"}]
    component]])

(defn login
  [page]
  [auth-wrap
   [fork/form {:keywordize-keys   true
               :form-id           "auth-form"
               :validation        #(vlad/field-errors validation/login-validations %)
               :prevent-default?  true
               :clean-on-unmount? true
               :on-submit         #(rf/dispatch [:login %])}
    (fn [{:keys [db
                 state
                 form-id
                 submitting?
                 on-submit-server-message
                 handle-submit]
          :as   props}]
      [:<>
       [:form
        {:id        form-id
         :on-submit handle-submit}
        [forms/fork-input props {:name        :user
                                 :type        :text
                                 :placeholder "Username"}]
        [forms/fork-input props {:name        :password
                                 :type        :password
                                 :placeholder "Password"}]
        [:div.input
         [:input.input
          {:id       :login
           :type     :submit
           :value    "Login"
           :disabled submitting?}]]
        (when config/is-auth0-available
          [:div.input
           [:a
            {:href (str config/site-api-origin
                        "/_site/openid/auth0/login"
                        "?return-to=" (. (. js/document -location) -origin) "/app/oauth-login")}
            "Login with Auth0"]])
        [auth-error on-submit-server-message]]

       [:div#create-account-wrap]])]])

(defn signup
  [page]
  [auth-wrap
   [fork/form {:path              :form
               :form-id           "auth-form"
               :keywordize-keys   true
               :validation        #(vlad/field-errors validation/signup-validations %)
               :prevent-default?  true
               :clean-on-unmount? true
               :on-submit         #(rf/dispatch [:signup %])}
    (fn [{:keys [form-id
                 submitting?
                 on-submit-server-message
                 handle-submit]
          :as   props}]
      [:<>
       [:form
        {:id        form-id
         :on-submit handle-submit}
        [forms/fork-input props {:name        :name
                                 :placeholder "Full name"}]
        [forms/fork-input props {:type        :email
                                 :placeholder "Email Address"}]
        [forms/fork-input props {:type        :password
                                 :placeholder "Password"}]
        [:div.input
         [:input.input
          {:id       :signup
           :type     :submit
           :value    "Signup"
           :disabled submitting?}]]]
       [auth-error on-submit-server-message]
       [:div#create-account-wrap
        [:p "Already have an account? "
         [:a {:href "/login"} "Login"]]]])]])

(defn profile-popover
  []
  (let [current-user @(rf/subscribe [::sub/current-user])]
  [:<>
   [:div.popover-backdrop
    {:on-click (fn [event]
                 (rf/dispatch [:toggle-settings])
                 (.preventDefault event)
                 (.stopPropagation event))}]
   [:div.popover__container
    {:data-side "right"}
    [:div.popover
     {:class (when @(rf/subscribe [:entered :settings])
               "entered")}
     [:div.popover__content
      [:div.popover__header
       [:i.popover__image.fas.fa-fw.fa-cog]
       [:div.info
        [:div.title "Account Settings"]
        [:a.description
         {:href     (nav/route->url :account-settings)
          :on-click #(rf/dispatch [:toggle-settings])
          :data-cy "profile"}
         "Edit Profile"]]]
      [:a.popover__item
      {:href (nav/route->url :notification-settings)}
       [:i.fas.fa-fw.fa-bell]
       [:span.text "Notification Settings"]]
      [:a.popover__item
       {:on-click #(rf/dispatch [:logout])
        :data-cy "logout"}
       [:i.fas.fa-fw.fa-sign-out-alt]
       [:span.text "Logout"]]
      [:a.popover__item
       {:href "/docs/EULA.pdf"
        :target "_blank"}
       [:i.fas.fa-fw.fa-file-contract]
       [:span.text "EULA"]]
      [:a.popover__item
       (if (contains? (set (:roles current-user)) "customer-user")
         {:href "https://virtulink.ricelake.com/cmr/index.htm"
          :target "_blank"}
         {:href "https://virtulink.ricelake.com/dlr/index.htm"
          :target "_blank"})
       [:i.fas.fa-fw.fa-question-circle]
       [:span.text "Help"]]]]
    [:div.popover-arrow.popover-arrow--profile]]]))

(defn forgot-password
  [page]
  [auth-wrap
   [fork/form {:path              :form
               :form-id           "auth-form"
               :keywordize-keys   true
               :validation        #(vlad/field-errors validation/email-validation %)
               :prevent-default?  true
               :clean-on-unmount? true
               :on-submit         #(rf/dispatch [::events/send-reset-password-link %])}
    (fn [{:keys [values
                 form-id
                 submitting?
                 handle-submit]
          :as   props}]
      [:<>
       [:form
        {:id        form-id
         :on-submit handle-submit}
        [forms/fork-input props {:type        :email
                                 :placeholder "Email Address"}]
        [:div.input
         [:input.input
          {:id       :reset
           :type     :submit
           :value    "Send reset email"
           :disabled submitting?}]]]
       [:div#create-account-wrap
        [:p "Remembered your password? " [:a {:href "/login"} "Login"]]]])]])

(defn reset-password
  [page]
  [auth-wrap
   [fork/form {:path              :form
               :form-id           "auth-form"
               :keywordize-keys   true
               :validation        #(vlad/field-errors validation/password-validation %)
               :prevent-default?  true
               :clean-on-unmount? true
               :on-submit         #(rf/dispatch [::events/set-password-submit %])}
    (fn [{:keys [values
                 form-id
                 submitting?
                 handle-submit]
          :as   props}]
      [:<>
       [:form
        {:id        form-id
         :on-submit handle-submit}
        [forms/fork-input props {:type        :password
                                 :placeholder "New Password"}]
        [:div.input
         [:input.input
          {:type     :submit
           :value    "Reset Password"
           :disabled submitting?}]]]
       [:div#create-account-wrap
        [:p "Remembered your password? " [:a {:href "/login"} "Login"]]]])]])

(defn merge-props
  [[element & children] props]
  (if (map? (first children))
    (into [element (merge (first children) props)]
          (drop 1 children))
    (into [element props]
          children)))

(defn button-with-dropdown
  [{:keys [button options state] :as props}]
  (assert button "You must supply a button component")
  (r/with-let [state (r/atom {:dropdown-open? false})]
    [:div.input-group
     {:on-blur (fn [event]
                 (swap! state assoc :dropdown-open? false))}

     (merge-props button
                  {:class "dropdown-toggle"
                   :type "button"
                   :on-click (fn [_]
                               (swap! state update :dropdown-open? not))})
     (when (:dropdown-open? @state)
       (into [:ul.dropdown-menu]
             (for [{:keys [label on-click]} options]
               [:li
                [:a.dropdown-item
                 {:on-mouse-down (fn [event]
                                   (.preventDefault event))
                  :on-click (fn [event]
                              (on-click event)
                              (swap! state assoc :dropdown-open? false))}
                 label]])))]))

(defn default-error-fallback
  [reset-error]
  [:div
   [:p "Something went wrong."]
   [:button {:on-click reset-error} "Try Again"]])

(defn error-boundary
  "Takes an options map of fallback component that is passed a function that will
  clear the error state, and a single component"
  [{:keys [fallback on-error]} comp]
  (let [error (r/atom nil)]
    (r/create-class
     {:component-did-catch (fn [this e info]
                             (comment "TODO Log errors to server here"))
      :get-derived-state-from-error (fn [e]
                                      (when on-error
                                        (on-error))
                                      (reset! error e)
                                      #js {})
      :reagent-render (fn [props comp]
                        (if @error
                          [(or fallback default-error-fallback)
                           #(reset! error nil)]
                          comp))})))

(defn confirmation-dialog
  [{:keys [action-fn text title]}]
  (rf/dispatch
   [:modal {:show? true
            :title title
            :child [:div.confirmation-dialog
                    [:div
                     [:p text]
                     [:button.btn.btn--action
                      {:type "button"
                       :on-click #(do (action-fn)
                                      (rf/dispatch [:modal {:show? false :child nil}]))}
                      "Confirm"]
                     [:button.btn
                      {:type "button"
                       :on-click #(rf/dispatch [:modal {:show? false :child nil}])}
                      "Cancel"]]]}]))
